import React from 'react';
import Link from 'gatsby-link';
import kebabCase from 'lodash.kebabcase';
import styles from '../../styles/navigation.module.styl';

const GroupNavigation = ({ pageId, groups }) => {
  return (
    <div className={styles.groupNavigation}>
      {groups.map(group => {
        const groupId = kebabCase(group.get('name'));
        return (
          <div key={groupId} className={styles.groupLink}>
            <Link className={styles.groupStartArrow} to={`/${pageId}/${groupId}/facts`}>
              <h2 className={styles.groupName}>{group.get('name')}</h2>
              <span className={styles.arrowText}>{"Let's start"}</span>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default GroupNavigation;



// WEBPACK FOOTER //
// ./src/components/navigation/GroupNavigation.js